import { RequestDetailed } from './RequestDetailed';

export default RequestDetailed;
